import { themeLight, Theme } from '@redislabsdev/redis-ui-styles';

export const themeUi: Theme = themeLight;
